const actions = {
  SET_STATE: 'cost-centers/SET_STATE',
  GET_DATA: 'cost-centers/GET_DATA',
}

export default actions
